import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, Switch, Typography} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {currencySymbol, getMediaURL, price, scrollTop, showSimpleDate, truncate} from "../../../../../config/values";
import Avatar from "@mui/material/Avatar";
import MakeDiscountCodeButton from "../MakeCharityButton";
import Box from '@mui/material/Box';
import {Trash, TicketPercent, SquareX, SquareCheckBig} from "lucide-react";
import MakeCharityButton from "../MakeCharityButton";
import {Link} from "react-router-dom";
import SubTitle from "../../../../components/elements/SubTitle";
import ItemsSkeleton from "../../../../components/loaders/ItemsSkeleton";
import {connect} from "trim-redux";

function DonorsTable({classes,setting}){
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([])
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const loadData = () =>{
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/best-donors`,config)
            .then(response => {
                setItems(response.data)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    useEffect(() => {
        loadData();
    }, []);
    return (
        <div className="donators-table ">
            {
                loading ?
                    <ItemsSkeleton length={setting.donors_table} xs={12} md={12} lg={12} height={60} style={{marginBottom:10}}/>
                    :
                <>
                    {
                        !!items.length &&
                        <SubTitle align="left" className="dialog-title mb-15">{t('bestDonors')}</SubTitle>
                    }
                    {
                        items.map((item,index) => (
                            <div className='donor-item flex-space' key={index}>
                                <Typography className="ranking">{index + 1}</Typography>
                                <Typography className="bold">{truncate(`${item.first_name} ${item.last_name}`, 14)}</Typography>
                                <Typography>{price(item.donates)} {currencySymbol}</Typography>

                            </div>
                        ))
                    }
                </>
            }
        </div>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(DonorsTable));
